/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_TitleInputs */

const tr_landing_pricing_title = /** @type {(inputs: Landing_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dürüst fiyatlandırma,`)
};

const en_landing_pricing_title = /** @type {(inputs: Landing_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honest pricing,`)
};

const de_landing_pricing_title = /** @type {(inputs: Landing_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehrliche Preise,`)
};

const ru_landing_pricing_title = /** @type {(inputs: Landing_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Честные цены,`)
};

/**
* | output |
* | --- |
* | "Honest pricing," |
*
* @param {Landing_Pricing_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_title = /** @type {((inputs?: Landing_Pricing_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_title(inputs)
	if (locale === "de") return de_landing_pricing_title(inputs)
	if (locale === "ru") return ru_landing_pricing_title(inputs)
	return tr_landing_pricing_title(inputs)
});